import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../service.service';

interface Department {
  _id?: string;
  department_id: string;
  department_code?: string;
  department_name?: string;
  department_Foreman_name?: string;
  is_factory?: boolean;
  warehouse_name?: string;
}

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css'],
})
export class DepartmentComponent implements OnInit {
  departments: Department[] = [];
  filteredDepartments: Department[] = [];

  isLoading = false;
  loadError: string | null = null;

  // Search text for filter
  searchText = '';

  constructor(
    private apiService: ServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadDepartments();
  }

  // ============================
  // API: Load all departments
  // ============================
  loadDepartments(): void {
    this.isLoading = true;
    this.loadError = null;

    // 🔹 Hard-coded to get up to 100 departments in one shot
    const query = '?limit=100';

    this.apiService.ViewDepartmentsPage(query).subscribe({
      next: (res: any) => {
        this.isLoading = false;

        if (res && res.success && Array.isArray(res.data)) {
          this.departments = res.data;
          this.applyFilters(); // apply current search
        } else {
          this.departments = [];
          this.filteredDepartments = [];
          this.loadError = 'Unable to load departments.';
        }
      },
      error: (err: any) => {
        console.error('Error loading departments:', err);
        this.isLoading = false;
        this.departments = [];
        this.filteredDepartments = [];
        this.loadError = 'Failed to load departments from server.';
      },
    });
  }

  // Reload button
  reload(): void {
    this.loadDepartments();
  }

  // ============================
  // Client-side filtering
  // ============================
  applyFilters(): void {
    const term = this.searchText.trim().toLowerCase();

    if (!term) {
      // no search -> show all
      this.filteredDepartments = [...this.departments];
      return;
    }

    this.filteredDepartments = this.departments.filter((d) => {
      const name = (d.department_name || '').toLowerCase();
      const code = (d.department_code || '').toLowerCase();
      const foreman = (d.department_Foreman_name || '').toLowerCase();
      const warehouse = (d.warehouse_name || '').toLowerCase();

      return (
        name.includes(term) ||
        code.includes(term) ||
        foreman.includes(term) ||
        warehouse.includes(term)
      );
    });
  }

  // ============================
  // Navigation
  // ============================
  viewDepartment(departmentId: string): void {
    if (!departmentId) {
      console.error('Missing department_id for view');
      return;
    }

    this.router.navigate(['/admin/department-detail'], {
      queryParams: { id: departmentId },
    });
  }

  editDepartment(departmentId: string): void {
    if (!departmentId) {
      console.error('Missing department_id for edit');
      return;
    }

    this.router.navigate(['/admin/department-edit-page'], {
      queryParams: { id: departmentId },
    });
  }

  // For *ngFor trackBy
  trackByDept(index: number, dept: Department): string {
    return dept.department_id || index.toString();
  }

  // Row click -> open detail
  onRowClick(dept: Department): void {
    if (!dept || !dept.department_id) {
      return;
    }
    this.viewDepartment(dept.department_id);
  }
}
